// Dashboard timeseries — данные для графиков

export type TimeseriesMetric = 'subscribers' | 'totalSpend' | 'botStarts'
export type TimeseriesPeriod = 'day' | 'week' | 'month' | 'quarter'

export interface TimeseriesPoint {
  date: string
  value: number
}

export interface TimeseriesSeries {
  from: string
  to: string
  points: TimeseriesPoint[]
}

export interface TimeseriesResponse {
  channelUUID: string
  metric: TimeseriesMetric
  period: TimeseriesPeriod
  current: TimeseriesSeries
  previous: TimeseriesSeries
}

const USE_MOCKS = false

function generateMockSeries(start: Date, days: number, baseValue: number, growth: number): TimeseriesSeries {
  const points: TimeseriesPoint[] = []
  let value = baseValue
  for (let i = 0; i < days; i++) {
    const d = new Date(start)
    d.setDate(d.getDate() + i)
    // Случайные колебания + тренд роста
    const variance = (Math.random() - 0.4) * growth * 0.5
    value += growth + variance
    points.push({
      date: d.toISOString().slice(0, 10),
      value: Math.max(0, Math.round(value)),
    })
  }
  const end = new Date(start)
  end.setDate(end.getDate() + days)
  return {
    from: start.toISOString(),
    to: end.toISOString(),
    points,
  }
}

export async function getTimeseries(
  channelUUID: string,
  metric: TimeseriesMetric,
  period: TimeseriesPeriod = 'month',
): Promise<TimeseriesResponse> {
  if (USE_MOCKS) {
    await new Promise((r) => setTimeout(r, 250))
    const days = period === 'day' ? 1 : period === 'week' ? 7 : period === 'month' ? 30 : 90
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    const currentStart = new Date(today)
    currentStart.setDate(currentStart.getDate() - days)
    const previousStart = new Date(currentStart)
    previousStart.setDate(previousStart.getDate() - days)

    const baseValue = metric === 'subscribers' ? 200 : metric === 'totalSpend' ? 1500 : 50
    const growth = metric === 'subscribers' ? 8 : metric === 'totalSpend' ? 600 : 2

    return {
      channelUUID,
      metric,
      period,
      current: generateMockSeries(currentStart, days, baseValue + growth * days * 0.6, growth),
      previous: generateMockSeries(previousStart, days, baseValue, growth * 0.7),
    }
  }

  const res = await fetch(
    `/api/max/dashboard/timeseries?channelUUID=${encodeURIComponent(channelUUID)}&metric=${metric}&period=${period}`,
    { credentials: 'include' },
  )
  if (!res.ok) throw new Error(`HTTP ${res.status}`)
  return res.json()
}
